import { useEffect, useState } from 'react';

const useTransitionToggle = (toggle, timeout) => {
    const [transitionExpand, setTransitionExpand] = useState(toggle);

    useEffect(() => {
        let transitionTimeout = void 0;
        if (toggle) {
            setTransitionExpand(toggle);
        } else {
            transitionTimeout = setTimeout(
                () => setTransitionExpand(toggle),
                timeout
            );
        }
        return () => clearTimeout(transitionTimeout);
    }, [toggle]);
    return transitionExpand;
};

export { useTransitionToggle as default, useTransitionToggle };
